export default "__VITE_ASSET__CRyFtf0F__"